import { Heading } from 'component-library/components/typography/Heading';
import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import React, { FC } from 'react';
import styled from 'styled-components';

import { ThreeStepSectionProps } from '.';
import { Step } from './Step';

const CompanionWrapper = styled(ShowOn)`
  padding-bottom: 88px;

  h4 {
    padding: 0 20px;
  }
`;

const Steps = styled.div`
  padding: 64px 20px 0;

  > div:not(:last-child) {
    padding-bottom: 54px;
  }
`;

const Image = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;

interface ThreeStepSectionSmallProps extends ThreeStepSectionProps {}

export const ThreeStepSectionSmall: FC<ThreeStepSectionSmallProps> = ({
  steps,
  image,
  heading,
}) => (
  <CompanionWrapper screens={[Screen.Sm, Screen.Md]}>
    <Heading variant={4} marginBottom={16}>
      {heading}
    </Heading>
    <Image>{image}</Image>
    <Steps>
      {steps.map((step, idx) => (
        <Step {...step} key={idx} />
      ))}
    </Steps>
  </CompanionWrapper>
);
